import React from "react";

import moment from "moment";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Toggle from "react-toggle";

import { isEnabled } from "utils/featureFlags";

import { ROLE_OPTIONS, ROLE_VALUES } from "containers/App/reducer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import NumericLabel from "react-pretty-numbers";

import { LineInput } from "components/Inputs/LineInput";
import Slider from "components/Inputs/Slider/ProjectSlider";
import SankeyChart from "components/Optimizer/SankeyChart";
import CapSlider from "components/ProjectOverview/CapSlider";
import ProfitSlider from "components/Project/ProfitSlider";
import PieChart from "components/Project/PieChart";
import RadarChart from "components/Project/RadarChart";
import AdvancedDeploy from "components/Project/AdvancedDeploy";
import TinyBarChart from "components/Project/TinyBarChart";
import ExplainBarChart from "components/Project/ExplainBarChart";
import BarChart from "components/Project/BarChart";
import ImpactSlider from "components/Optimizer/ImpactSlider";

import AssumptionLegend from "components/Project/AssumptionLegend";

import { colorsTwo } from "components/Project/AssumptionLegend";

import RunItemContainer from "containers/View/Item/RunItem";
import RunViewContainer from "containers/View/Run";
import RunPlotContainer from "containers/RunPlot/RunPlot";
import { isShowSharingAndAssumptions } from "containers/Project/reducer";
import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";

import WizardContainer from "containers/Wizard/Wizard";
import MonitoringContainer from "containers/Monitoring/Monitoring";

import FeatureChartContainer from "containers/FeatureChart/FeatureChart";

import FrontierSlidersContainer from "containers/FrontierSliders/FrontierSliders";
import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import ProjectDeploymentContainer from "containers/Deployments/ProjectDeployment";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Waterfall from "components/Waterfall/Waterfall";

import ModelError from "components/Results/ModelError";

import ContinuousRunFrontier from "components/FrontierSliders/ContinuousRunFrontier";

import CompareScenario from "components/Project/CompareScenario";
import DeployScenario from "components/Project/nDeployScenario";

import { AIBLE_VIEW_TYPE, isSameSetup, PROJECT_MODES } from "containers/Project/reducer";
import ProjectHeaderContainer from "containers/Project/ProjectHeader";

import numeral from "numeral";

import RefreshIcon from "images/refresh.svg";

import styles from "./style.module.css";

// TODO: Super lazy blocking the help chat

const RIGHT_PANEL_WIDTH = "500px";

const darkSelectStyle = {
  option: (provided, state) => ({
    ...provided,
    background: state.isFocused ? "#512f77" : "#362e30",
    color: "white !important"
  }),
  control: (provided, state) => ({
    ...provided,
    background: "#362e44",
    border: "1px solid #828282",
    color: "white !important"
    // none of react-select's styles are passed to <Control />
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "white"
  }),
  menuList: (provided, state) => ({
    ...provided,
    paddingTop: "0px",
    paddingBottom: "0px"
  })
};

const numberFormatParams = {
  shortFormat: true,
  shortFormatMinValue: 0,
  precision: 1,
  justification: "L",
  locales: "en-US"
};

export default class Project extends React.PureComponent {
  constructor(props) {
    super(props);

    const isContinuous =
      props &&
      props.optimized &&
      props.optimized.bestModel &&
      props.optimized.bestModel.metrics &&
      props.optimized.bestModel.metrics.overImpact !== undefined &&
      props.optimized.bestModel.metrics.underImpact !== undefined;

    this.state = {
      isRightOpen: false,
      isAFO: false,
      isEditSales: false,
      isEditMarketing: false,
      isEditSalesImpacts: false,
      isEditMarketingImpacts: false,
      isHideCustomValues: false,
      isSetup: false,
      timePeriod: { value: "Month", label: "Month" },
      drilldownColumn: undefined,
      setupSections: {},
      sharingOptions: {},
      recalibrate: {},
      isHistory: false,
      isCreating: false,
      isCompare: false,
      isCreatingScenario: false,
      userFilter: "All",
      isDeploy: false,
      isDeployScreen: false,
      isShowCurrentState: false,
      compareElement: isContinuous ? "Error Cost" : "Profit",
      scenarioName: props.userName ? props.userName + "'s Scenario" : "New Scenario"
    };
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  renderAssumptionPanel() {
    const { approveAssumption, restoreAssumption, deleteAssumption, rerunSegment, viewAssumption, project, optimized } =
      this.props;

    const { isHistory } = this.state;

    const activeSegment =
      project &&
      project.segments &&
      project.settings &&
      project.settings.runId &&
      project.segments.filter((s) => s.job && s.job.job_id === project.settings.runId).length > 0
        ? project.segments.filter((s) => s.job && s.job.job_id === project.settings.runId)[0]
        : undefined;

    if (activeSegment === undefined) {
      return <div />;
    }

    const draftSetups = activeSegment.history.assumptions.filter((a) => a.status === "DRAFT");

    const historySetups = activeSegment.history.assumptions.filter((a) => a.status === "ACCEPTED");

    const shouldRerun = isSameSetup(activeSegment.assumption.data, optimized.setup.jobSetup) === false;

    const isOverallSegment = this.getIsOverallSegment();

    return (
      <div className={styles.rContent}>
        <div className={styles.rHeader}>
          <div className={styles.hOverflow}>{activeSegment.name === "" ? "Overall" : activeSegment.name}</div>
          {isOverallSegment ? (
            <div />
          ) : (
            <div className={styles.tHolder}>
              <span style={{ marginRight: "5px" }}>{"Show History"}</span>
              <Toggle
                defaultChecked={isHistory}
                icons={false}
                onChange={(e) =>
                  this.setState({
                    isHistory: e.target.checked
                  })
                }
              />
              <span className={isHistory ? styles.yPos : styles.nPos}>{isHistory ? "On" : "Off"}</span>
            </div>
          )}
        </div>
        <div className={styles.rightPanelBody}>
          <div className={styles.activeAssumption}>
            <div className={styles.assSubHeader}>
              {isOverallSegment ? "Overall Assumption" : "Approved Assumption"}
              {isOverallSegment || isSameSetup(activeSegment.assumption.data, optimized.setup) ? (
                <div className={styles.viewing} style={{ marginRight: "20px" }}>
                  {"Viewing"}
                </div>
              ) : (
                <Button
                  style={{ marginRight: "20px", fontWeight: "normal" }}
                  onClick={() => viewAssumption(activeSegment.assumption.data)}
                >
                  {"View"}
                </Button>
              )}
            </div>
            <div className={styles.assumptions}>
              {this.renderAssumptionsSetup(isOverallSegment ? optimized.setup : activeSegment.assumption.data)}
              {isOverallSegment ? (
                <div className={styles.segmentButtonHolder} style={{ marginTop: "10px" }}>
                  {"This is a weighted average of all segment assumptions"}
                </div>
              ) : (
                <div className={styles.segmentButtonHolder} style={{ marginTop: "10px" }}>
                  <Button
                    style={{ marginRight: "20px", whiteSpace: "nowrap" }}
                    onClick={() => rerunSegment(optimized.segmentId)}
                    disabled={shouldRerun === false}
                  >
                    {"Retrain Models"}
                  </Button>
                  {shouldRerun ? (
                    <div>{"Aible recommends retraining the models based on the assumption changes"}</div>
                  ) : (
                    <div>{"Same assumptions as current frontier"}</div>
                  )}
                </div>
              )}
            </div>
          </div>
          {isOverallSegment !== true && isHistory ? (
            <div className={styles.rBody}>
              <div className={styles.assSubHeader}>{"Previous Approved Assumptions"}</div>
              <div className={styles.assHolder}>
                {historySetups.length > 0 ? (
                  historySetups.map((a, k) => (
                    <div className={styles.assumptions} key={k}>
                      <div className={styles.assSubHeader} style={{ fontWeight: "normal", marginLeft: "0px" }}>
                        <div title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
                          {"Applied " + moment.utc(a.created_date).local().fromNow()}
                        </div>
                        {isSameSetup(a.data, optimized.setup) ? (
                          <div className={styles.viewing}>{"Viewing"}</div>
                        ) : (
                          <Button onClick={() => viewAssumption(a.data)}>{"View"}</Button>
                        )}
                      </div>
                      {this.renderAssumptionsSetup(a.data, activeSegment.assumption.data)}
                      <div className={styles.butHolder}>
                        <div>
                          <div className={styles.uHeader}>{"REQUESTED BY:"}</div>
                          <div className={styles.aUser}>{a.created_by.fullname}</div>
                        </div>
                        <div style={{ marginLeft: "60px" }}>
                          <div className={styles.uHeader}>{"REQUESTED DATE:"}</div>
                          <div
                            className={styles.aUser}
                            title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                          >
                            {moment.utc(a.created_date).local().fromNow()}
                          </div>
                        </div>
                      </div>
                      <div className={styles.segmentButtonHolder}>
                        <Button style={{ marginRight: "10px" }} onClick={() => restoreAssumption(a.id)}>
                          {"Restore"}
                        </Button>
                        {/*
                      <Button style={{ marginRight: "10px" }}>
                        {"Review"}
                      </Button>
                    */}
                        <Button onClick={() => deleteAssumption(a.id)}>{"Delete"}</Button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>{"No new requests"}</div>
                )}
              </div>
            </div>
          ) : (
            <div className={styles.rBody}>
              <div className={styles.assSubHeader}>{"Pending Scenarios"}</div>
              <div className={styles.assHolder}>
                {draftSetups.length > 0 ? (
                  draftSetups.map((a, k) => (
                    <div className={styles.assumptions} key={k}>
                      <div className={styles.assSubHeader} style={{ fontWeight: "normal", marginLeft: "0px" }}>
                        <div title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
                          {"Applied " + moment.utc(a.created_date).local().fromNow()}
                        </div>
                        {isSameSetup(a.data, optimized.setup) ? (
                          <div className={styles.viewing}>{"Viewing"}</div>
                        ) : (
                          <Button onClick={() => viewAssumption(a.data)}>{"View"}</Button>
                        )}
                      </div>
                      {this.renderAssumptionsSetup(a.data, activeSegment.assumption.data)}
                      <div className={styles.butHolder}>
                        <div>
                          <div className={styles.uHeader}>{"REQUESTED BY:"}</div>
                          <div className={styles.aUser}>{a.created_by.fullname}</div>
                        </div>
                        <div style={{ marginLeft: "60px" }}>
                          <div className={styles.uHeader}>{"REQUESTED DATE:"}</div>
                          <div
                            className={styles.aUser}
                            title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                          >
                            {moment.utc(a.created_date).local().fromNow()}
                          </div>
                        </div>
                      </div>
                      <div className={styles.segmentButtonHolder}>
                        <Button onClick={() => approveAssumption(a.id)}>{"Approve"}</Button>
                        <Button onClick={() => deleteAssumption(a.id)}>{"Decline"}</Button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ marginLeft: "20px" }}>{"No new requests"}</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSharing() {
    const {
      addUserRoleToSegment,
      deleteUserRoleFromSegment,
      deleteUserFromProject,
      patchUserRoleSegment,
      updateProjectSetting,
      isLoadingSharing,
      modelGroups,
      project,
      users,
      userName
    } = this.props;

    const { sharingOptions } = this.state;

    const roleOptions = ROLE_OPTIONS;

    return (
      <div className={styles.rContent}>
        <div className={styles.rHeader}>{"Sharing and Permissions"}</div>
        <div className={styles.shareHolder}>
          {project &&
            project.segments &&
            project.segments.map((s, i) => {
              const subKey = s.id;

              const userKey = subKey + "-user";
              const roleKey = subKey + "-role";

              const roles = s.roles.filter((r) => s.conditions.length == 0 || r.role_type != "VIEWER");

              const sRoleOptions = roleOptions.filter(({ value }) => s.conditions.length == 0 || value != "VIEWER");

              const userRole =
                s.roles.filter((r) => r.role_user.fullname === userName).length > 0
                  ? s.roles.filter((r) => r.role_user.fullname === userName)[0].role_type
                  : undefined;

              const overallRole =
                project.roles && project.roles.filter((r) => r.role_user.fullname === userName).length > 0
                  ? project.roles.filter((r) => r.role_user.fullname === userName)[0].role_type
                  : undefined;

              return (
                <div className={styles.shareItem} key={i}>
                  <div className={styles.rSubHeader}>
                    {s.name === ""
                      ? project.segments.length > 1 && userRole === "OWNER"
                        ? "Add to All Subgroups"
                        : "Overall"
                      : s.name
                        ? s.name.replace("@@_@@Other@@_@@", "Other")
                        : s.name}
                  </div>
                  {/*
                <LineInput
                  isMediumBox
                  placeholder="Edit Description"
                />
                */}
                  {sharingOptions[subKey] && sharingOptions[subKey].isEdit ? (
                    <div className={styles.userEdit}>
                      {overallRole === "OWNER" &&
                        (isLoadingSharing ? (
                          <div className={styles.loadingShare}>
                            {"Adding user... "}
                            <LoadingIndicator style={{ margin: "0px", marginLeft: "20px" }} />
                          </div>
                        ) : (
                          <div className={styles.userItem} style={{ marginBottom: "20px" }}>
                            <div className={styles.userName} style={{ overflow: "visible" }}>
                              <Select
                                options={
                                  users
                                    ? users
                                        .filter(
                                          (u) =>
                                            u.fullname === undefined ||
                                            userName === undefined ||
                                            u.fullname !== userName
                                        )
                                        .map((u) => ({
                                          label: u.fullname,
                                          value: u.id
                                        }))
                                    : []
                                }
                                ref={userKey}
                              />
                            </div>
                            <div className={styles.userRoleSelect}>
                              <Select options={sRoleOptions} defaultValue={sRoleOptions[0]} ref={roleKey} />
                            </div>
                            <Button
                              onClick={() => {
                                addUserRoleToSegment(
                                  s.id,
                                  this.refs[userKey].state.value.value,
                                  this.refs[roleKey].state.value.value
                                );

                                this.refs[userKey].state.value = undefined;
                                this.refs[roleKey].state.value = sRoleOptions[0];
                              }}
                            >
                              {"Invite"}
                            </Button>
                          </div>
                        ))}
                      {s.name === "" && project.segments.length > 1 ? (
                        <div />
                      ) : (
                        roles.map((r, i) => (
                          <div key={i} className={styles.userItem}>
                            <div className={styles.userName}>{r.role_user.fullname}</div>
                            {r.role_user.fullname === userName ? (
                              <div className={styles.lockedRole}>
                                {r.role_type ? r.role_type.toLowerCase() : r.role_type}
                              </div>
                            ) : (
                              <div className={styles.uItem}>
                                <div className={styles.userRoleSelect}>
                                  <Select
                                    options={sRoleOptions}
                                    defaultValue={ROLE_VALUES[r.role_type]}
                                    onChange={(val) => patchUserRoleSegment(r.id, val.value)}
                                  />
                                </div>
                                <Button onClick={() => deleteUserFromProject(r.role_user.id)}>{"Delete"}</Button>
                              </div>
                            )}
                          </div>
                        ))
                      )}
                      <Button
                        onClick={() =>
                          this.setState({
                            sharingOptions: {
                              ...sharingOptions,
                              [subKey]: {
                                ...sharingOptions[subKey],
                                isEdit: false
                              }
                            }
                          })
                        }
                      >
                        {"Done"}
                      </Button>
                    </div>
                  ) : s.name === "" && project.segments.length > 1 && userRole === "OWNER" ? (
                    <div>
                      <a
                        onClick={() =>
                          this.setState({
                            sharingOptions: {
                              ...sharingOptions,
                              [subKey]: {
                                ...sharingOptions[subKey],
                                isEdit: true
                              }
                            }
                          })
                        }
                      >
                        {"Add Users"}
                      </a>
                    </div>
                  ) : (
                    <div>
                      <span>{roles.length + " Collaborator" + (roles.length > 1 ? "s" : "")}</span>
                      {userRole === "OWNER" && (
                        <a
                          onClick={() =>
                            this.setState({
                              sharingOptions: {
                                ...sharingOptions,
                                [subKey]: {
                                  ...sharingOptions[subKey],
                                  isEdit: true
                                }
                              }
                            })
                          }
                          style={{ marginLeft: "5px" }}
                        >
                          {"Edit"}
                        </a>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
        <div className={styles.eFooter}>
          <Button onClick={() => updateProjectSetting("isSharing", false)}>{"Close Sharing"}</Button>
        </div>
      </div>
    );
  }

  renderExplain() {
    const { project, modelGroups, optimized } = this.props;
    const { isExplainConversion, isExplainResource } = this.state;

    const groups =
      modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues.filter((v) => v.value !== "Overall")
        : [];

    const conversionRate = groups.map((v) => ({
      label: v.value,
      ["Conversion Rate"]: (
        (v.bestModel.maxIteration.averageWinRate * 100).toFixed(2) -
        (v.setup.truePositive / (v.setup.truePositive + v.setup.falsePositive)) * 100
      ).toFixed(2)
    }));

    const resourceAllocation = groups.map((v) => ({
      label: v.value,
      ["Relative Resource Allocation"]: (((v.optimalPct - v.currentCost) / (v.currentCost / 2)) * 100).toFixed(2)
    }));

    /* TODO: Maybe show overall later
    const oCRate =
      conversionRate.length === 0 && modelGroups.drilldownValues.length === 1
        ? (
            (Number(modelGroups.drilldownValues[0].setup.truePositive) /
              (Number(modelGroups.drilldownValues[0].setup.truePositive) +
                Number(modelGroups.drilldownValues[0].setup.falsePositive))) *
            100
          ).toFixed(2) + "%"
        : undefined;

    const oImpCRate =
      conversionRate.length === 0 && modelGroups.drilldownValues.length === 1
        ? (
            (Number(modelGroups.drilldownValues[0].setup.truePositive) /
              (Number(modelGroups.drilldownValues[0].setup.truePositive) +
                Number(modelGroups.drilldownValues[0].setup.falsePositive))) *
            100
          ).toFixed(2) + "%"
        : undefined;
    */

    return (
      <div className={styles.explain}>
        <div className={styles.eHeader}>{"Aible Compared to Current Strategy"}</div>
        {isExplainConversion ? (
          <div className={styles.eContent} style={{ padding: "20px" }}>
            <div className={styles.eMiniHeader} style={{ marginTop: "0px" }}>
              {"Conversion Rate Detail"}
            </div>
            <div className={styles.eLegend}>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#E0E0E0" }} />
                {"CURRENT STATE"}
              </div>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#7E69D7" }} />
                {"AIBLE"}
              </div>
            </div>
            {groups.map((v, i) => {
              const trueAction = v && v.setup && v.setup.trueAction ? v.setup.trueAction : "Pursued";
              const truePositiveLabel = v && v.setup ? v.setup.truePositiveLabel : "True Positive";

              const pursued = v && v.setup ? Number(v.setup.truePositive) + Number(v.setup.falsePositive) : 0;
              const aiblePursued =
                v && v.bestModel && v.bestModel.maxIteration
                  ? Number(v.bestModel.maxIteration.confusionMatrix.tp) +
                    Number(v.bestModel.maxIteration.confusionMatrix.fp)
                  : 0;

              const currentTruePositive = v && v.setup ? v.setup.truePositive : 0;
              const aibleTruePositive =
                v && v.bestModel && v.bestModel.maxIteration
                  ? v && v.bestModel && v.bestModel.maxIteration.confusionMatrix.tp
                  : 0;

              return (
                <div className={styles.eItemSub} key={i}>
                  <div className={styles.eItemHeader}>{v.value}</div>
                  <div className={styles.eSubItem}>{trueAction}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + trueAction,
                          [trueAction]: aiblePursued
                        },
                        {
                          label: "Current " + trueAction,
                          [trueAction]: pursued
                        }
                      ]}
                      dKey={trueAction}
                      unit={optimized.unitLabelShort}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aiblePursued).format("0.0a")}</div>
                      <div>{numeral(pursued).format("0.0a")}</div>
                    </div>
                  </div>
                  <div className={styles.eSubItem}>{truePositiveLabel}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + truePositiveLabel,
                          [truePositiveLabel]: aibleTruePositive
                        },
                        {
                          label: "Current " + truePositiveLabel,
                          [truePositiveLabel]: currentTruePositive
                        }
                      ]}
                      dKey={truePositiveLabel}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aibleTruePositive).format("0.0a")}</div>
                      <div>{numeral(currentTruePositive).format("0.0a")}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : isExplainResource ? (
          <div className={styles.eContent} style={{ padding: "20px" }}>
            <div className={styles.eMiniHeader} style={{ marginTop: "0px" }}>
              {"Resource Allocation Detail"}
            </div>
            <div className={styles.eLegend}>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#E0E0E0" }} />
                {"CURRENT STATE"}
              </div>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#7E69D7" }} />
                {"AIBLE"}
              </div>
            </div>
            {groups.map((v, i) => {
              const resourcingLabel = v && v.setup ? v.setup.advancedCostLabel : "Resourcing";
              const profitLabel = v && v.setup ? v.setup.netImpactLabel : "Profit";

              const currentResource = v ? v.currentCost : 0;
              const aibleResource = v ? v.optimalPct : 0;

              const currentProfit = v ? v.currentProfit : 0;
              const aibleProfit = v ? v.profit : 0;

              return (
                <div className={styles.eItemSub} key={i}>
                  <div className={styles.eItemHeader}>{v.value}</div>
                  <div className={styles.eSubItem}>{resourcingLabel}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + resourcingLabel,
                          [resourcingLabel]: aibleResource
                        },
                        {
                          label: "Current " + resourcingLabel,
                          [resourcingLabel]: currentResource
                        }
                      ]}
                      dKey={resourcingLabel}
                      unit={optimized.unitLabelShort}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aibleResource).format("0.0a")}</div>
                      <div>{numeral(currentResource).format("0.0a")}</div>
                    </div>
                  </div>
                  <div className={styles.eSubItem}>{profitLabel}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + profitLabel,
                          [profitLabel]: aibleProfit
                        },
                        {
                          label: "Current " + profitLabel,
                          [profitLabel]: currentProfit
                        }
                      ]}
                      dKey={profitLabel}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aibleProfit).format("0.0a")}</div>
                      <div>{numeral(currentProfit).format("0.0a")}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.eContent}>
            <div className={styles.eItem} style={{ marginTop: "0px" }}>
              <div className={styles.eMiniHeader}>{"Improved Conversion Rate"}</div>
              <div className={styles.eBody}>
                {"Aible's optimized AI did a better job of targeting the transactions that are most likely to convert."}
                <div>
                  <a onClick={() => this.setState({ isExplainConversion: true })}>{"Learn More"}</a>
                </div>
                <BarChart bars={conversionRate} unit={"%"} label={"Conversion Rate"} />
              </div>
            </div>
            <div className={styles.eItem} style={{ borderTop: "1px solid rgba(0, 0, 0, 0.2)" }}>
              <div className={styles.eMiniHeader}>{"Improved Relative Resource Allocation"}</div>
              <div className={styles.eBody}>
                {"Aible's reallocated the available resources more optimally across subgroups."}
                <div>
                  <a onClick={() => this.setState({ isExplainResource: true })}>{"Learn More"}</a>
                </div>
                <BarChart bars={resourceAllocation} unit={"%"} label={"Relative Resource Allocation"} />
              </div>
            </div>
          </div>
        )}
        <div
          className={styles.eFooter}
          style={
            isExplainResource || isExplainConversion
              ? {
                  justifyContent: "space-between",
                  marginLeft: "20px",
                  marginRight: "20px"
                }
              : {}
          }
        >
          <Button onClick={() => this.setState({ isExplain: false })}>{"Close Explanation"}</Button>
          {isExplainConversion || isExplainResource ? (
            <Button
              onClick={() =>
                this.setState({
                  isExplainConversion: false,
                  isExplainResource: false
                })
              }
            >
              {"Back to Overview"}
            </Button>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }

  renderFooterDeployScreen() {
    const { isAFO } = this.props;
    const { isAdvancedDeploy } = this.state;

    return (
      <div
        className={styles.footerHolder}
        style={{
          width: isAFO ? "calc(100% - 500px)" : "100%",
          justifyContent: "center"
        }}
      >
        <div className={styles.fSection}>
          <Button
            onClick={() =>
              this.setState({
                isDeploy: false,
                isAdvancedDeploy: false,
                isDeployScreen: false
              })
            }
          >
            {"Back to Overview"}
          </Button>
        </div>
      </div>
    );
  }

  renderFooterDeploy() {
    const { isAFO, deploy, updateAibleViewType } = this.props;

    const { isAdvancedDeploy } = this.state;

    return (
      <div
        className={styles.footerHolder}
        style={{
          width: isAFO ? "calc(100% - 500px)" : "100%",
          justifyContent: "center"
        }}
      >
        <div className={styles.fSection}>
          <Button onClick={() => this.setState({ isDeploy: false, isAdvancedDeploy: false })}>
            {"Back to Overview"}
          </Button>
          <Button
            style={{ marginLeft: "10px" }}
            type={"primary"}
            onClick={() => {
              deploy();
              updateAibleViewType(AIBLE_VIEW_TYPE.DEPLOYMENT);
              this.setState({ isDeploy: false, isAdvancedDeploy: false });
            }}
          >
            {"Approve and Deploy New Strategy"}
          </Button>
        </div>
      </div>
    );
  }

  renderFooter() {
    const {
      allScenarios,
      project,
      optimized,
      modelGroups,
      viewScenario,
      deleteScenario,
      refresh,
      isAFO,
      aibleViewType,
      shortlistScenario,
      compareScenarioIndex,
      updateCompareScenarioIndex,
      updateShowPending,
      updateShowShortListed,
      selectedScenario,
      saveScenario,
      showPending,
      showShortListed,
      viewingScenarioIndex,
      canEditSegments
    } = this.props;
    const {
      isCompare,
      isExplain,
      isDeploy,
      isDeployScreen,
      isAdvancedDeploy,
      isCreatingScenario,
      userFilter,
      typeFilter,
      scenarioName
    } = this.state;

    if (isDeployScreen) {
      return this.renderFooterDeployScreen();
    }

    if (isDeploy || isAdvancedDeploy) {
      return this.renderFooterDeploy();
    }

    let hasSameScenario = false;

    const userOptions =
      project && project.roles
        ? project.roles.map((r) => ({
            label: r.role_user.fullname,
            value: r.role_user.id
          }))
        : [];

    const sOptions = [{ label: "All Users", value: "All" }].concat(userOptions);

    const typeOptions = [
      { label: "All Scenarios", value: "All" },
      { label: "Shortlisted", value: "Shortlisted" },
      { label: "Pending", value: "Pending" }
    ];

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    const isOnlyOverall = project && project.segments && project.segments.length <= 1;

    return (
      <div className={styles.footerHolder} style={{ width: isAFO ? "calc(100% - 500px)" : "100%" }}>
        <div className={styles.fSection}>
          {aibleViewType === AIBLE_VIEW_TYPE.BUSINESS && (
            <div style={{ marginRight: "10px" }}>
              <Button
                onClick={() => refresh()}
                style={
                  project && project.settings && project.settings.isRefreshing
                    ? {
                        height: "35px",
                        width: "51px",
                        position: "relative",
                        pointerEvents: "none"
                      }
                    : {}
                }
              >
                {project && project.settings && project.settings.isRefreshing ? (
                  <LoadingIndicator
                    color={"#333"}
                    style={{
                      height: "13px",
                      width: "13px",
                      margin: "0px",
                      position: "absolute",
                      transform: "scale(0.4)",
                      top: "0px",
                      left: "8px"
                    }}
                  />
                ) : (
                  <img src={RefreshIcon} style={{ height: "13px", width: "13px" }} />
                )}
              </Button>
            </div>
          )}
          <div className={styles.scenarioPicker} style={{ marginRight: "10px" }}>
            <Select
              options={typeOptions}
              value={
                typeOptions.filter((s) => s.value === typeFilter).length > 0
                  ? typeOptions.filter((s) => s.value === typeFilter)[0]
                  : { label: "All Scenarios", value: "All" }
              }
              menuPlacement={"top"}
              onChange={(val) => this.setState({ typeFilter: val.value })}
            />
          </div>
          <div className={styles.scenarioPicker}>
            <Select
              options={sOptions}
              value={
                sOptions.filter((s) => s.value === userFilter).length > 0
                  ? sOptions.filter((s) => s.value === userFilter)[0]
                  : { label: "All Users", value: "All" }
              }
              menuPlacement={"top"}
              onChange={(val) => this.setState({ userFilter: val.value })}
            />
          </div>
          {allScenarios ? (
            <ButtonGroup
              style={{
                marginLeft: "10px",
                maxWidth: "375px",
                overflowX: "auto"
              }}
            >
              {allScenarios
                .sort((a, b) => a.index - b.index)
                .filter((s) => s.scenario !== undefined)
                .map((s, i) => {
                  let isSameScenario = true;
                  Object.keys(s.scenario)
                    .filter((c, i, sList) => sList.length === 1 || i > 0 || true)
                    .sort((a, b) => (a === "Overall" ? -1 : b === "Overall" ? 1 : a < b ? -1 : 1))
                    .forEach((k, i, sList) => {
                      if (modelGroups.drilldownValues[i] === undefined) {
                        isSameScenario = false;
                      } else if (
                        isSameSetup(s.scenario[k].setup.data, modelGroups.drilldownValues[i].oSetup) === false
                      ) {
                        isSameScenario = false;
                      }
                    });

                  if (isSameScenario === true) {
                    hasSameScenario = true;
                  }

                  let shouldRender =
                    userFilter === "All" ||
                    (s.originalScenario &&
                      s.originalScenario.created_by &&
                      userFilter === s.originalScenario.created_by.id);

                  shouldRender =
                    shouldRender &&
                    (typeFilter === "Pending" && s.originalScenario.status === "PENDING" ? false : true);

                  shouldRender =
                    shouldRender &&
                    (typeFilter === "Shortlisted" && s.originalScenario.status === "DRAFT" ? false : true);

                  return !shouldRender ? (
                    <div key={i} />
                  ) : (
                    <OverlayTrigger
                      key={i}
                      placement="top"
                      trigger={["hover"]}
                      rootClose
                      overlay={
                        <Popover id="popover-positioned-top" title={s.originalScenario.name}>
                          <div className={styles.resoucePopup}>
                            <div className={styles.tooltipLine}>
                              <div>{"Created By"}</div>
                              <div>{s.originalScenario.created_by.fullname}</div>
                            </div>
                            <div className={styles.tooltipLine}>
                              <div>{"Created On"}</div>
                              <div>
                                {moment.utc(s.originalScenario.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                              </div>
                            </div>
                            <div className={styles.tooltipLine}>
                              <div>{"Status"}</div>
                              <div>{s.originalScenario.status}</div>
                            </div>
                          </div>
                        </Popover>
                      }
                    >
                      <Button
                        key={i}
                        className={styles.footerBtn}
                        onClick={isCompare ? () => updateCompareScenarioIndex(i) : () => viewScenario(s.scenario, i)}
                        onMouseOver={
                          isCompare && compareScenarioIndex !== i ? () => updateCompareScenarioIndex(i) : () => {}
                        }
                        active={
                          isCompare
                            ? false
                            : (s && viewingScenarioIndex === s.index) ||
                              isSameScenario ||
                              (isCompare && compareScenarioIndex === i)
                        }
                        style={
                          isCompare && viewingScenarioIndex === s.index
                            ? { border: "2px solid rgb(239, 126, 84)" }
                            : isCompare && compareScenarioIndex === s.index
                              ? { border: "2px solid rgb(126, 105, 215)" }
                              : {}
                        }
                      >
                        {s.originalScenario ? s.originalScenario.name : i}
                      </Button>
                    </OverlayTrigger>
                  );
                })}
              <Button disabled={hasSameScenario} active={hasSameScenario === false}>
                {"New"}
              </Button>
            </ButtonGroup>
          ) : (
            <div />
          )}
          {hasSameScenario ? (
            <div />
          ) : (
            <div className={styles.nameInput}>
              <LineInput
                isMediumBox
                defaultValue={scenarioName}
                onChange={(val) => this.setState({ scenarioName: val })}
              />
            </div>
          )}
          <ButtonGroup>
            <Button
              disabled={hasSameScenario || isCreatingScenario}
              style={{ marginLeft: "10px" }}
              type={"primary"}
              onClick={() => {
                this.setState({ isCreatingScenario: true });
                setTimeout(() => this.setState({ isCreatingScenario: false }), 5000);
                setTimeout(() => saveScenario(scenarioName), 1);
              }}
            >
              {"Save"}
            </Button>
            <Button
              disabled={
                !canEditSegments ||
                (selectedScenario &&
                selectedScenario.originalScenario &&
                selectedScenario.originalScenario.status === "DRAFT" &&
                hasSameScenario === true
                  ? false
                  : true)
              }
              type={"primary"}
              onClick={() => shortlistScenario()}
            >
              {"Shortlist"}
            </Button>
            <Button onClick={() => deleteScenario()}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </ButtonGroup>
        </div>
        <div className={styles.fSection}>
          <Button
            onClick={() => this.setState({ isCompare: !isCompare })}
            disabled={selectedScenario === undefined || allScenarios.length < 2}
            active={isCompare}
          >
            {"Compare"}
          </Button>
          <Button
            style={{ marginLeft: "10px" }}
            type={"primary"}
            disabled={
              optimized.isCreating ||
              selectedScenario === undefined ||
              selectedScenario.originalScenario.status === "DRAFT"
            }
            onClick={() => this.setState({ isCompare: false, isDeploy: !isDeploy })}
          >
            {selectedScenario === undefined || selectedScenario.originalScenario.status === "DRAFT"
              ? "Shortlist Scenario to Deploy"
              : "Deploy Strategy"}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const {
      optimizer,
      optimized,
      activeSegment,
      project,
      selectRun,
      history,
      modelGroups,
      segmentOptions,
      runs,
      match,
      isAFO,
      isSharing,
      projectMode,
      updateProjectMode,
      handleCreateDrilldown,
      updateDrilldownValue,
      rerunSegment,
      setFirstRunId,
      setSecondRunId,
      updateAibleViewType
    } = this.props;
    const {
      mode,
      isEditSales,
      isEditMarketing,
      isRightOpen,
      isDeploy,
      isAdvancedDeploy,
      isDeployScreen,
      isAssumptions,
      isExplain,
      timePeriod,
      drilldownColumn,
      isSetup,
      isCompare
    } = this.state;

    const aibleViewType = optimizer && optimizer.aibleViewType;

    if (optimized === undefined || optimized.isLoading) {
      return (
        <div className={styles.optimizer}>
          <div className={styles.loading}>
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "-20%",
                marginBottom: "50px",
                transform: "scale(1.75)"
              }}
            />
            <div className={styles.loadMsg}>{"Loading project..."}</div>
          </div>
        </div>
      );
    }

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    if (match && match.params && match.params.isBusiness && match.params.isBusiness === "one") {
      return (
        <WizardContainer
          projectId={project ? project.id : undefined}
          id={optimized.id}
          isConsumerMode
          isPreviewMode
          activeSegment={optimized ? optimized.activeSegment : undefined}
          isOverallSegment={this.getIsOverallSegment()}
          modelGroups={modelGroups}
          segmentOptions={segmentOptions}
          optimizer={optimizer}
          updateDrilldownValue={updateDrilldownValue}
        />
      );
    }

    return (
      <div className={styles.optimizer}>
        {optimized.isLoading !== true && optimized.isCreating !== true ? this.renderFooter() : <div />}
        <div className={styles.aibleForOne} style={{ width: isAFO ? RIGHT_PANEL_WIDTH : "0px" }}>
          {isAFO && (
            <WizardContainer
              projectId={project ? project.id : undefined}
              id={optimized.id}
              isConsumerMode
              isPreviewMode
              activeSegment={optimized ? optimized.activeSegment : undefined}
              isOverallSegment={this.getIsOverallSegment()}
              modelGroups={modelGroups}
              segmentOptions={segmentOptions}
              optimizer={optimizer}
              updateDrilldownValue={updateDrilldownValue}
            />
          )}
        </div>
        <div
          className={styles.rightP}
          style={{
            width: isSharing ? RIGHT_PANEL_WIDTH : "0px",
            marginTop: "0px",
            height: "calc(100% - 60px)"
          }}
        >
          {isSharing && this.renderSharing()}
        </div>
        <div
          className={styles.rightP}
          style={{
            width: isExplain ? RIGHT_PANEL_WIDTH : "0px",
            height: "calc(100% - 60px)",
            marginTop: "0px"
          }}
        >
          {isExplain && this.renderExplain()}
        </div>
        <div
          className={styles.pBody}
          style={{
            width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
          }}
        >
          {isDeploy || isCompare ? (
            <div />
          ) : (
            <ProjectHeaderContainer
              id={project ? project.id : undefined}
              blueprintId={optimized ? optimized.blueprintId : undefined}
              runId={optimized ? optimized.id : undefined}
              isDark
              hideBlueprint
            />
          )}
          {projectMode === PROJECT_MODES.VIEW_SEGMENTS ? (
            <RunViewContainer
              hideFirstTile
              hideShowMore
              projectId={project.id}
              projectUpdateView={() => updateProjectMode(PROJECT_MODES.OVERALL)}
            />
          ) : aibleViewType === AIBLE_VIEW_TYPE.MONITORING ? (
            <MonitoringContainer id={project.id} />
          ) : aibleViewType === AIBLE_VIEW_TYPE.DEPLOYMENT ? (
            <ProjectDeploymentContainer id={project && project.id} />
          ) : aibleViewType === AIBLE_VIEW_TYPE.ADVANCED && false ? (
            <WizardContainer id={optimized.id} projectId={project ? project.id : undefined} />
          ) : aibleViewType === AIBLE_VIEW_TYPE.BUSINESS || true ? (
            isDeploy ? (
              <DeployScenario {...this.props} />
            ) : isCompare ? (
              <CompareScenario {...this.props} onClose={() => this.setState({ isCompare: false })} />
            ) : (
              <React.Fragment>
                {optimized.errors && optimized.errors.length > 0 ? (
                  <div className={styles.optimizerEmpty}>
                    <ModelError errors={optimized.errors} aibleViewType={aibleViewType} />
                    <div className={styles.retrain}>
                      <Button onClick={() => rerunSegment(optimized.segmentId)}>{"Retrain Frontier"}</Button>
                    </div>
                  </div>
                ) : optimized.isLoading || optimized.isCreating ? (
                  <div className={styles.optimizerEmpty}>
                    <div className={styles.loading}>
                      <LoadingIndicator
                        style={{
                          margin: "0px",
                          marginTop: "-20%",
                          marginBottom: "50px",
                          transform: "scale(1.75)"
                        }}
                      />
                      <div className={styles.loadMsg}>
                        {optimized.isCreating ? "Generating frontier..." : "Loading frontier..."}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>{this.renderOverall()}</div>
                )}
              </React.Fragment>
            )
          ) : (
            ""
          )}
        </div>
        {this.renderRightPanel()}
      </div>
    );
  }

  renderProfitBox(style, hideButton = false) {
    const { project, optimized, optimizer, modelGroups, optimalProfit, optimalCost } = this.props;

    const { isExplain } = this.state;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    const isOnlyOverall = project && project.segments && project.segments.length <= 1;

    return (
      <div className={styles.newItemMid} style={{ ...style }}>
        <div className={styles.wItemHeader}>{"Expected Wins (Optimized)"}</div>
        {optimized.isCreatingSplit ? (
          <div className={styles.newOItemContent}>
            <LoadingIndicator style={{ marginTop: "-20px" }} />
            <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
          </div>
        ) : (
          <div className={styles.newOItemContent}>
            <div className={styles.cHero}>
              {optimized.isCurrencyUnitType ? (
                <div className={styles.sHero}>{numeral(optimized.totalWon).format("0.0a")}</div>
              ) : (
                <div className={styles.sHero} style={{ display: "block" }}>
                  {numeral(optimized.totalWon).format("0.0a")}
                  <div className={styles.subLabel}>{optimized.unitLabel}</div>
                </div>
              )}
            </div>
            <TinyBarChart
              bars={[
                {
                  label: "Optimal Wins",
                  Total: optimized.totalWon
                },
                {
                  label: "Current Wins",
                  Total: optimized.currentTotalWon
                }
              ]}
              dataKey={"Total"}
            />
            {!isOnlyOverall && !isContinuous && (
              <a onClick={() => this.setState({ isExplain: !isExplain })} className={styles.learnWhy}>
                {"Learn Why"}
              </a>
            )}
          </div>
        )}
      </div>
    );
  }

  renderRecalibrateOutcomePercentage() {
    const {
      optimizer,
      optimized,
      modelGroups,
      project,
      scaledTotal,
      updateScaledTotal,
      updateOutcomePercentage,
      isBusinessReality,
      updateIsBusinessReality
    } = this.props;
    const { recalibrate } = this.state;
    if (!optimized) {
      return <div />;
    }
    const outcome = optimized.dataset && optimized.dataset.outcome;
    const toPredict = optimized.setup && optimized.setup.success && optimized.setup.success.label;

    const isOverallSegment = this.getIsOverallSegment();

    const segmentLabel =
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions &&
      optimized.innerSegment.conditions.length > 0
        ? optimized.innerSegment.conditions[0].value
        : "Overall";

    return (
      <div className={styles.oItemBotContent} style={{ overflowX: "hidden", marginTop: "6px" }}>
        {isOverallSegment ? (
          modelGroups.drilldownValues
            .filter((d) => d.value !== "Overall")
            .map((d, i) => (
              <div className={styles.fSlider} key={i}>
                <div className={styles.tMsg}>{d.value}</div>
                {d.currentOutcomePercentage === d.outcomePercentage && recalibrate[d.value] !== true ? (
                  <a
                    onClick={() =>
                      this.setState({
                        recalibrate: { ...recalibrate, [d.value]: true }
                      })
                    }
                  >
                    {"Click to recalibrate"}
                  </a>
                ) : (
                  <div>
                    <div className={styles.tSlider}>
                      <div>{"Current State"}</div>
                      <div style={{ paddingLeft: "20px" }}>
                        <Slider
                          value={(d.currentOutcomePercentage * 100).toPrecision(3)}
                          min={0}
                          max={100}
                          step={0.1}
                          endLabel={"% " + toPredict}
                          isLocked
                          inputWidth={50}
                          isProject
                          color={"#868595"}
                        />
                      </div>
                    </div>
                    <React.Fragment>
                      <div className={styles.tSlider} style={{ marginTop: "10px" }}>
                        <div>{"Expected Future Percentage"}</div>
                        <div style={{ paddingLeft: "20px" }}>
                          <Slider
                            value={(d.outcomePercentage * 100).toPrecision(3)}
                            onAfterChange={() => this.props.resetBudget()}
                            onChange={(val) => updateOutcomePercentage(d.runId, val / 100)}
                            min={0}
                            max={100}
                            step={0.1}
                            endLabel={"% " + toPredict}
                            inputWidth={50}
                            isProject
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  </div>
                )}
              </div>
            ))
        ) : (
          <div className={styles.countItem}>
            <div className={styles.countEditOne}>{segmentLabel}</div>
            <div className={styles.countEditTwo}>
              {Number(optimized.currentOutcomePercentage * 100).toFixed(2) + "%"}
            </div>
            <div className={styles.countEditThree}>{Number(optimized.outcomePercentage * 100).toFixed(2) + "%"}</div>
          </div>
        )}
        {isOverallSegment ? <div /> : <div />}
        {isOverallSegment === false && isBusinessReality === false ? (
          <React.Fragment>
            <div
              className={styles.tSlider}
              style={{
                marginBottom: "10px",
                marginTop: "20px",
                marginLeft: "5px"
              }}
            >
              <div>{"Expected Future Percentage"}</div>
              <Slider
                value={(optimized.outcomePercentage * 100).toPrecision(3)}
                onAfterChange={() => this.props.resetBudget()}
                onChange={(val) => updateOutcomePercentage(optimized.innerId, val / 100)}
                min={0}
                max={100}
                step={0.1}
                endLabel={"% " + toPredict}
                inputWidth={50}
                isProject
              />
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }

  getLabelFromSegment(segment) {
    return segment.conditions.length === 0 ? "Overall" : segment.conditions[0].value;
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderSharingSegment(segment) {
    const { allScenarios, project, optimized, updateDrilldownValue, updateShowShortListed } = this.props;
    const { isAssumptions } = this.state;

    const isOverallSegment = this.getIsOverallSegment();

    return (
      <div key={segment.id}>
        {isOverallSegment ? (
          <div className={styles.sharingTableRow}>
            {this.getLabelFromSegment(segment)}
            <div className={styles.sharingTableCell}>{segment.roles.length}</div>
          </div>
        ) : (
          segment.roles.map((r, i) => {
            const editCount = allScenarios.filter((s) => {
              return (
                segment &&
                segment.conditions &&
                segment.conditions.length > 0 &&
                s.originalScenario &&
                s.originalScenario.created_by &&
                s.originalScenario.created_by.id === r.role_user.id &&
                s.originalScenario.status === "DRAFT" &&
                s.originalScenario.elements &&
                s.originalScenario.elements.filter(
                  (e) => e.assumption_id === s.scenario[segment.conditions[0].value].setup.id
                ).length > 0
              );
            }).length;

            return editCount === 0 ? (
              <div className={styles.sharingTableRow} key={i}>
                {r.role_user.fullname}
                <div className={styles.sharingTableCell}>{editCount}</div>
              </div>
            ) : (
              <a
                key={i}
                className={styles.sharingTableRow}
                onClick={() => {
                  updateShowShortListed(false);
                  return this.setState({
                    userFilter: r.role_user.id
                  });
                }}
              >
                {r.role_user.fullname}
                <div className={styles.sharingTableCell}>{editCount}</div>
              </a>
            );
          })
        )}
      </div>
    );
  }

  renderOverviewEdit() {
    return <div>{"Eweww"}</div>;
  }

  renderOverall() {
    const {
      optimized,
      optimizer,
      project,
      createSplits,
      modelGroups,
      continuousFrontier,
      groupInfo,
      isBusinessReality,
      setMinBudget,
      setMaxBudget,
      isAFO,
      isSharing,
      scaledTotal,
      setSalesBudget,
      selectedScenario,
      sliderView,
      updateInnerId,
      updateDrilldownValue,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsBusinessReality,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative,
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      updateCustomValue
    } = this.props;

    const {
      isOverviewEdit,
      isExplain,
      isEditMarketing,
      isEditSales,
      isEditMarketingImpacts,
      isEditSalesImpacts,
      isHideCustomValues,
      showShortListed,
      showPending,
      isAssumptions,
      isCreating,
      isShowCurrentState,
      scenarioName,
      recalibrate
    } = this.state;

    const topDrivers =
      modelGroups &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue).length > 0
        ? modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue)[0]
        : undefined;

    let mTotal = 0;
    if (groupInfo.marketing[optimizer.drilldownValue]) {
      Object.keys(groupInfo.marketing[optimizer.drilldownValue]).forEach((v) => {
        mTotal += groupInfo.marketing[optimizer.drilldownValue][v].cost;
      });
    }

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = isHideCustomValues !== true && hasCustomValues;

    const splitOptions =
      optimized && optimized.dataset
        ? Object.keys(optimized.dataset.fields)
            .filter((f) => optimized.dataset.fields[f].type === "categorical" && f !== optimized.dataset.outcome)
            .filter((f) =>
              optimized && optimized.setup && optimized.setup.ignored && optimized.setup.ignored[f] ? false : true
            )
            .map((f) => ({
              label: optimized.dataset.fields[f].label,

              value: optimized.dataset.fields[f].label
            }))
        : [];

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    let loadingSplits = false;

    otherSlices &&
      otherSlices.forEach((v) => {
        if (isNaN(v.optimalPct)) {
          loadingSplits = true;
        }
      });

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const maxBudgetSetup =
      optimized && optimized.setup
        ? (Number(optimized.setup.truePositive) +
            Number(optimized.setup.falsePositive) +
            Number(optimized.setup.trueNegative) +
            Number(optimized.setup.falseNegative)) *
          (optimized.setup.advancedCost !== undefined
            ? Math.abs(optimized.setup.advancedCost)
            : Math.abs(optimized.setup.advancedCost))
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const shouldRerun =
      optimized &&
      optimized.activeSegment &&
      optimized.activeSegment.assumption &&
      isSameSetup(optimized.activeSegment.assumption.data, optimized.setup.jobSetup) === false;

    const outcome = optimized.dataset && optimized.dataset.outcome;
    const toPredict = optimized.setup && optimized.setup.success && optimized.setup.success.label;

    const isEditCounts = !isBusinessReality;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    if (isContinuous) {
      loadingSplits = false;

      otherSlices &&
        otherSlices.forEach((v) => {
          if (v.bestModel === undefined) {
            loadingSplits = true;
          }
        });
    }

    return (
      <div className={styles.overall}>
        <div
          className={styles.currentToggle}
          style={{
            width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
          }}
        >
          {optimized.hasSameScenario && selectedScenario ? (
            <div className={styles.cToggle}>
              <div>
                {selectedScenario.originalScenario.created_by.fullname + ": " + selectedScenario.originalScenario.name}
              </div>
              <div className={styles.cHolder}></div>
            </div>
          ) : (
            <div className={styles.cToggle}>
              <div>{"New Scenario: " + scenarioName}</div>
              <div className={styles.cHolder}></div>
            </div>
          )}
        </div>
        {isContinuous ? (
          <div
            className={styles.overallSection}
            style={{
              width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
            }}
          >
            <div className={styles.mItem}>
              <div className={styles.newItemMid}>
                <div className={styles.wItemHeader}>{"Optimal Mix"}</div>
                <div className={styles.newOItemContent} style={{ overflow: "visible" }}>
                  {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
                    <div className={styles.splitFieldHolder}>
                      <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
                        {"Split on Field"}
                      </div>
                      <div className={styles.splitField}>
                        <Select options={splitOptions} ref="splitOne" />
                      </div>
                      <Button
                        onClick={() => {
                          this.setState({ isCreating: true });
                          setTimeout(() => this.setState({ isCreating: false }), 5000);
                          createSplits(
                            this.refs["splitOne"].state.value !== null
                              ? this.refs["splitOne"].state.value.value
                              : undefined
                          );
                        }}
                      >
                        {"Create Subgroups"}
                      </Button>
                    </div>
                  ) : loadingSplits || isCreating ? (
                    <div className={styles.smallLoader} style={{ padding: "2vw" }}>
                      <LoadingIndicator style={{ marginTop: "-20px" }} />
                      <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                    </div>
                  ) : (
                    <div>
                      <div className={styles.pieHolder}>
                        <PieChart
                          secondaryColors
                          pData={
                            otherSlices
                              ? otherSlices.map((s) => ({
                                  name: s.value,
                                  runId: s.runId,
                                  value: Math.abs(
                                    Math.round(s.bestModel.metrics.overImpact + s.bestModel.metrics.underImpact)
                                  ),
                                  color: s.value === optimizer.drilldownValue ? "#F47C20" : s.color
                                }))
                              : []
                          }
                          onClick={(runId, name) => updateDrilldownValue(runId, name)}
                          unit={optimized.unitLabelShort}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.mItem}>
              <div className={styles.newItemMid}>
                <div className={styles.wItemHeader}>{"Optimized Under Prediction Cost"}</div>
                {optimized.isCreatingSplit ? (
                  <div className={styles.newOItemContent}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div className={styles.newOItemContent}>
                    <div className={styles.cHero}>
                      {optimized.isCurrencyUnitType ? (
                        <div className={styles.sHero}>{numeral(optimized.underEstimate).format("0.0a")}</div>
                      ) : (
                        <div className={styles.sHero} style={{ display: "block" }}>
                          {numeral(optimized.underEstimate).format("0.0a")}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.mItem}>
              <div className={styles.newItemMid}>
                <div className={styles.wItemHeader}>{"Optimized Over Prediction Cost"}</div>
                {optimized.isCreatingSplit ? (
                  <div className={styles.newOItemContent}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div className={styles.newOItemContent}>
                    <div className={styles.cHero}>
                      {optimized.isCurrencyUnitType ? (
                        <div className={styles.sHero}>{numeral(optimized.overEstimate).format("0.0a")}</div>
                      ) : (
                        <div className={styles.sHero} style={{ display: "block" }}>
                          {numeral(optimized.overEstimate).format("0.0a")}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.mItem}>
              <div className={styles.newItemMid}>
                <div className={styles.wItemHeader}>{"Aible Optimized Error Cost"}</div>
                {optimized.isCreatingSplit ? (
                  <div className={styles.newOItemContent}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div className={styles.newOItemContent}>
                    <div className={styles.cHero}>
                      {optimized.isCurrencyUnitType ? (
                        <div className={styles.sHero}>
                          {numeral(optimized.overEstimate + optimized.underEstimate).format("0.0a")}
                        </div>
                      ) : (
                        <div className={styles.sHero} style={{ display: "block" }}>
                          {numeral(optimized.overEstimate + optimized.underEstimate).format("0.0a")}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            className={styles.overallSection}
            style={{
              width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
            }}
          >
            <div className={styles.mItem}>
              <div>
                <div
                  className={styles.midHeaderHolder}
                  style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
                >
                  <div className={styles.bHeader}>{"Current " + optimized.resourcingLabel}</div>
                  <div>
                    {optimized.isCurrencyUnitType ? (
                      <div className={styles.sHero}>
                        {optimized.unitLabel}
                        {numeral(optimized.currentSpend).format("0.0a")}
                      </div>
                    ) : (
                      <div className={styles.sHero} style={{ display: "block" }}>
                        {numeral(optimized.currentSpend).format("0.0a")}
                        <div className={styles.subLabel}>{optimized.unitLabel}</div>
                      </div>
                    )}
                    <div
                      className={
                        styles.oItemHeader +
                        " " +
                        (optimized.currentSpend > optimized.totalCost
                          ? styles.oItemHeaderNegative
                          : styles.oItemHeaderPositive)
                      }
                    >
                      <div className={styles.leftRadius} />
                      <div className={styles.oIContent}>
                        <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: "5px" }} />
                        {(optimized.currentSpend > optimized.totalCost ? "Overspending by " : "Underspending by ") +
                          (Math.abs(
                            Math.round((optimized.totalCost - optimized.currentSpend) / (optimized.currentSpend || 1))
                          ) > 2
                            ? Math.abs(
                                Math.round(
                                  (optimized.totalCost - optimized.currentSpend) / (optimized.currentSpend || 1)
                                )
                              ) + "x"
                            : Math.round(
                                Math.abs(
                                  (optimized.totalCost - optimized.currentSpend) / (optimized.currentSpend || 1)
                                ) * 100
                              ) + "%")}
                      </div>
                      <div className={styles.rightRadius} />
                    </div>
                  </div>
                </div>
                <div className={styles.newItemMid}>
                  {isEditMarketing === true ? (
                    <div className={styles.bHeaderHolder}>
                      <div className={styles.wItemHeader}>{"Edit Resource Constraints"}</div>
                      <div className={styles.newOItemContent} style={{ color: "#333" }}>
                        <div className={styles.tInput} style={{ marginTop: "20px" }}>
                          <LineInput
                            topLabel={"Maximum"}
                            isMediumBox
                            onChange={(val) =>
                              setMaxBudget(optimized.id, isNaN(val) || val === "" ? undefined : Number(val))
                            }
                            value={maxBudget ? maxBudget : "No Constraint"}
                            forceCommas
                          />
                        </div>
                        <div className={styles.tInput}>
                          <LineInput
                            topLabel={"Aible Optimal (Constrained)"}
                            isMediumBox
                            isDisabled
                            value={optimized.totalCost}
                            forceCommas
                          />
                        </div>
                        <div className={styles.tInput}>
                          <LineInput
                            topLabel={"Minimum"}
                            isMediumBox
                            onChange={(val) =>
                              setMinBudget(optimized.id, isNaN(val) || val === "" ? undefined : Number(val))
                            }
                            value={minBudget ? minBudget : "No Constraint"}
                            forceCommas
                          />
                        </div>
                        <div className={styles.closeHolder}>
                          <Button
                            onClick={() => this.setState({ isEditMarketing: false })}
                            style={{ marginBottom: "10px" }}
                          >
                            {"Close Editor"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className={styles.wItemHeader}>
                        {"Optimal " + optimized.resourcingLabel}
                        {/* REMOVING THIS FOR NOW
                        <FontAwesomeIcon
                          className={styles.editIcon}
                          icon={faEdit}
                          onClick={() =>
                            this.setState({ isEditMarketing: true })
                          }
                        />
                        */}
                      </div>
                      {optimized.isCreatingSplit ? (
                        <div className={styles.newOItemContent}>
                          <LoadingIndicator style={{ marginTop: "-20px" }} />
                          <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                        </div>
                      ) : (
                        <div className={styles.newOItemContent}>
                          <div className={styles.cHero}>
                            {optimized.isCurrencyUnitType ? (
                              <div className={styles.sHero}>
                                {optimized.unitLabel}
                                {numeral(optimized.totalCost).format("0.0a")}
                              </div>
                            ) : (
                              <div className={styles.sHero} style={{ display: "block" }}>
                                {numeral(optimized.totalCost).format("0.0a")}
                                <div className={styles.subLabel}>{optimized.unitLabel}</div>
                              </div>
                            )}
                          </div>
                          <TinyBarChart
                            bars={[
                              {
                                label: "Optimal " + optimized.resourcingLabel,
                                Cost: optimized.totalCost
                              },
                              {
                                label: "Current " + optimized.resourcingLabel,
                                Cost: optimized.currentSpend
                              }
                            ]}
                            unit={optimized.unitLabel}
                            isCurrencyUnit={optimized.isCurrencyUnitType}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.mItem}>
              <div
                className={styles.midHeaderHolder}
                style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
              >
                <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                  {"Current Mix"}
                </div>
                {project && project.segments && project.segments.length === 1 ? (
                  <div className={styles.smallPieHolder}>{"Select field to split"}</div>
                ) : (
                  <div className={styles.smallPieHolder}>
                    <PieChart
                      isSmall
                      secondaryColors
                      pData={
                        otherSlices
                          ? otherSlices.map((s) => ({
                              name: s.value,
                              runId: s.runId,
                              value: Math.round(s.currentCost),
                              color: s.value === optimizer.drilldownValue ? "#F47C20" : s.color
                            }))
                          : []
                      }
                      onClick={(runId, name) => updateDrilldownValue(runId, name)}
                      unit={optimized.unitLabelShort}
                    />
                  </div>
                )}
              </div>
              <div className={styles.newItemMid}>
                <div className={styles.wItemHeader}>{"Optimal Mix"}</div>
                <div className={styles.newOItemContent} style={{ overflow: "visible" }}>
                  {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
                    <div className={styles.splitFieldHolder}>
                      <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
                        {"Split on Field"}
                      </div>
                      <div className={styles.splitField}>
                        <Select options={splitOptions} ref="splitOne" />
                      </div>
                      <Button
                        onClick={() => {
                          this.setState({ isCreating: true });
                          setTimeout(() => this.setState({ isCreating: false }), 5000);
                          createSplits(
                            this.refs["splitOne"].state.value !== null
                              ? this.refs["splitOne"].state.value.value
                              : undefined
                          );
                        }}
                      >
                        {"Create Subgroups"}
                      </Button>
                    </div>
                  ) : loadingSplits || isCreating ? (
                    <div className={styles.smallLoader} style={{ padding: "2vw" }}>
                      <LoadingIndicator style={{ marginTop: "-20px" }} />
                      <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                    </div>
                  ) : (
                    <div>
                      <div className={styles.pieHolder}>
                        <PieChart
                          secondaryColors
                          pData={
                            otherSlices
                              ? otherSlices.map((s) => ({
                                  name: s.value,
                                  runId: s.runId,
                                  value: Math.round(s.optimalPct),
                                  color: s.value === optimizer.drilldownValue ? "#F47C20" : s.color
                                }))
                              : []
                          }
                          onClick={(runId, name) => updateDrilldownValue(runId, name)}
                          unit={optimized.unitLabelShort}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.mItem}>
              <div
                className={styles.midHeaderHolder}
                style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
              >
                <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                  {"Current " + optimized.revenueLabel}
                </div>
                {optimized.isCurrencyUnitType ? (
                  <div className={styles.sHero}>
                    {optimized.unitLabel}
                    {numeral(optimized.currentRevenue).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.sHero} style={{ display: "block" }}>
                    {numeral(optimized.currentRevenue).format("0.0a")}
                    <div className={styles.subLabel}>{optimized.unitLabel}</div>
                  </div>
                )}
                <div style={{ height: "20px" }} />
              </div>
              <div className={styles.newItemMid}>
                <div className={styles.wItemHeader}>{"Expected Pursued"}</div>
                {optimized.isCreatingSplit ? (
                  <div className={styles.newOItemContent}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div className={styles.newOItemContent}>
                    <div className={styles.cHero}>
                      {optimized.isCurrencyUnitType ? (
                        <div className={styles.sHero}>{numeral(optimized.totalPursued).format("0.0a")}</div>
                      ) : (
                        <div className={styles.sHero} style={{ display: "block" }}>
                          {numeral(optimized.totalPursued).format("0.0a")}
                        </div>
                      )}
                    </div>
                    <TinyBarChart
                      bars={[
                        {
                          label: "Expected Pursued",
                          Total: optimized.totalPursued
                        },
                        {
                          label: "Current Pursued",
                          Total: optimized.currentTotalPursued
                        }
                      ]}
                      dataKey={"Total"}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className={styles.mItem}>
              <div className={styles.bHeaderHolder}>
                <div
                  className={styles.midHeaderHolder}
                  style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
                >
                  <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                    {"Current " + optimized.profitLabel}
                  </div>
                  {optimized.isCurrencyUnitType ? (
                    <div className={styles.sHero}>
                      {optimized.unitLabel}
                      {numeral(optimized.currentProfit).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.sHero} style={{ display: "block" }}>
                      {numeral(optimized.currentProfit).format("0.0a")}
                      <div className={styles.subLabel}>{optimized.unitLabel}</div>
                    </div>
                  )}
                  {isNaN(Math.abs(optimized.currentRevenue - optimized.currentSpend - optimized.currentProfit)) ? (
                    <div>&nbsp;</div>
                  ) : (
                    <div>
                      {"After " + optimized.unitLabelShort}
                      <span>
                        {numeral(
                          Math.abs(optimized.currentRevenue - optimized.currentSpend - optimized.currentProfit)
                        ).format("0.0a")}
                      </span>
                      {" in other costs"}
                    </div>
                  )}
                </div>
              </div>
              {this.renderProfitBox()}
            </div>
          </div>
        )}
        {isOverviewEdit === true ? (
          <div
            className={styles.midHolder}
            style={isShowCurrentState ? { marginTop: "340px" } : { marginTop: "240px" }}
          >
            <div className={styles.midBody}>
              <div className={styles.midHeader} style={{ background: "#7E69D7", color: "white" }}>
                <div className={styles.midItemEdit}>{"Overview"}</div>
                <div className={styles.midItemEdit} style={{ textAlign: "center" }}>
                  {"Prediction Drivers"}
                </div>
                <div className={styles.midItemEditLarge}>{"Editing Assumptions"}</div>
                <div className={styles.midEdit}>
                  <Button onClick={() => this.setState({ isOverviewEdit: false })} type={"primary"}>
                    {"Save Updates"}
                  </Button>
                </div>
              </div>
              {modelGroups &&
                modelGroups.drilldownValues &&
                modelGroups.drilldownValues
                  .filter((d) => d.value !== "Overall")
                  .map((d, i) => {
                    const selectedModel = d.capModels[Math.round(d.capValue) + "%"];

                    let retModels = { ...d.capModels };

                    const activeSegment = project.segments.filter((s) => s.id === d.segmentId)[0];

                    const currScenario =
                      (selectedScenario && selectedScenario.scenario && selectedScenario.scenario[d.value]) || {};

                    const scenarioSetup = currScenario.setup || {};

                    const currRunId = currScenario.runId;

                    const frontierMin = 0;
                    const frontierMax = 100;

                    const showMetrics = [
                      { value: "accuracy_score", label: "Accuracy" },
                      { value: "precision_score", label: "Precision" },
                      { value: "recall_score", label: "Recall" },
                      { value: "auc", label: "AUC" },
                      { value: "f1_score", label: "F1 Score" },
                      { value: "log_loss", label: "Log Loss" }
                    ];

                    const setupMetrics = [
                      { value: "conversionGain", label: "truePositiveLabel" },
                      {
                        value: "conversionCost",
                        label: "falsePositiveLabel"
                      }
                    ];

                    return (
                      <div className={styles.midItemHolder} key={i}>
                        <div className={styles.midItemEdit}>
                          <div className={styles.midFlex}>
                            <div
                              className={styles.midIcon}
                              style={{
                                background: d.color
                              }}
                            />
                            {d.value}
                          </div>
                          <div className={styles.slideSelectHolder}>
                            <CapSlider
                              key={"cap" + d.value + i}
                              isEditFrontierRange={false}
                              frontierRange={[frontierMin, frontierMax]}
                              impacts={
                                project.settings && project.settings.scenarios
                                  ? [
                                      ...project.settings.scenarios
                                        .filter((s, i) =>
                                          showShortListed === false &&
                                          project.settings.originalScenarios &&
                                          project.settings.originalScenarios[i] &&
                                          project.settings.originalScenarios[i].status === "PENDING"
                                            ? false
                                            : true
                                        )
                                        .filter((s, i) =>
                                          showPending === false &&
                                          project.settings.originalScenarios &&
                                          project.settings.originalScenarios[i] &&
                                          project.settings.originalScenarios[i].status === "DRAFT"
                                            ? false
                                            : true
                                        )
                                        .map((s, i) => ({
                                          value: Math.min(s[d.value].capValue, 100),
                                          drilldownValue: "Scenario " + i
                                        })),
                                      {
                                        value: d.capValue,
                                        drilldownValue: d.value
                                      }
                                    ]
                                  : [
                                      {
                                        value: d.capValue,
                                        drilldownValue: d.value
                                      }
                                    ]
                              }
                              currentImpact={Math.min(d.capValue, 100)}
                              drilldownValue={d.value}
                              capModels={retModels}
                              drilldown={d}
                            />
                          </div>
                        </div>
                        <div className={styles.midItemEdit} style={{ height: "500px" }}>
                          <FeatureChartContainer
                            id={d.runId}
                            isHideSelect
                            predictMode={"predict"}
                            featureStyle={{
                              border: "none",
                              margin: "0px",
                              background: "white"
                            }}
                            isTabMini
                            isProjectOverview
                            projectId={project ? project.id : undefined}
                            hideRight
                          />
                        </div>
                        <div className={styles.midItemEditLarge}>
                          <div className={styles.midFlexHelp}>
                            <div className={styles.midEditSection}>
                              <div className={styles.midEditItemHeader}>{"Cost and Benefits Ratio"}</div>
                              <div>
                                <div className={styles.shareHeader}>
                                  <div className={styles.costEditOne}>{"Measure"}</div>
                                  <div className={styles.costEditOne}>{"Initial State"}</div>
                                  <div className={styles.costEditTwo}>{"Expected (New)"}</div>
                                </div>
                                <div className={styles.aHolder}>
                                  {Object.keys(d.setup.customValues).map((v, i) => {
                                    const showWarning = checkValueWarning(
                                      d.setup.customValues[v],
                                      d.setup.defaultSetup.data.customValues[v]
                                    );
                                    return (
                                      <div key={i} className={styles.assumptionEditItem}>
                                        <div className={styles.costEditOne} style={{ paddingLeft: "5px" }}>
                                          {v}
                                        </div>
                                        <div className={styles.costEditOne}>
                                          {d.setup.defaultSetup &&
                                          d.setup.defaultSetup.data &&
                                          d.setup.defaultSetup.data.customValues
                                            ? d.setup.defaultSetup.data.customValues[v]
                                            : d.setup.customValues[v]}
                                        </div>
                                        <div className={styles.costEditTwo}>
                                          <LineInput
                                            isMediumBox
                                            value={d.setup.customValues[v]}
                                            onChange={(val) => updateCustomValue(d.runId, d.setup.blueprintId, v, val)}
                                            isWarning={showWarning}
                                            warning={
                                              showWarning &&
                                              getWarningMessage(
                                                d.setup.customValues[v],
                                                d.setup.defaultSetup.data.customValues[v],
                                                undefined,
                                                "Initial State"
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                              <div className={styles.assumptionEditItem}>
                                <div className={styles.costEditOne} style={{ paddingLeft: "5px" }}>
                                  {d.setup.truePositiveLabel}
                                </div>
                                <div className={styles.costEditOne}>{d.setup.defaultSetup.data.conversionGain}</div>
                                <div className={styles.costEditOne}>
                                  <LineInput
                                    isMediumBox
                                    value={d.setup.conversionGain}
                                    onChange={(val) => updateConversionGain(d.runId, val)}
                                  />
                                </div>
                              </div>
                              <div className={styles.assumptionEditItem}>
                                <div className={styles.costEditOne} style={{ paddingLeft: "5px" }}>
                                  {d.setup.falsePositiveLabel}
                                </div>
                                <div className={styles.costEditOne}>{d.setup.defaultSetup.data.conversionCost}</div>
                                <div className={styles.costEditOne}>
                                  <LineInput
                                    isMediumBox
                                    value={d.setup.conversionCost}
                                    onChange={(val) => updateConversionCost(d.runId, val)}
                                  />
                                </div>
                              </div>
                              <div className={styles.assumptionEditItem}>
                                <div className={styles.costEditOne} style={{ paddingLeft: "5px" }}>
                                  {d.setup.trueNegativeLabel}
                                </div>
                                <div className={styles.costEditOne}>{d.setup.defaultSetup.data.conversionSaved}</div>
                                <div className={styles.costEditOne}>
                                  <LineInput
                                    isMediumBox
                                    value={d.setup.conversionSaved}
                                    onChange={(val) => updateConversionMissed(d.runId, val)}
                                  />
                                </div>
                              </div>
                              <div className={styles.assumptionEditItem}>
                                <div className={styles.costEditOne} style={{ paddingLeft: "5px" }}>
                                  {d.setup.falseNegativeLabel}
                                </div>
                                <div className={styles.costEditOne}>{d.setup.defaultSetup.data.conversionMissed}</div>
                                <div className={styles.costEditOne}>
                                  <LineInput
                                    isMediumBox
                                    value={d.setup.conversionMissed}
                                    onChange={(val) => updateConversionMissed(d.runId, val)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className={styles.midEditSection}>
                              <div className={styles.midEditItemHeader}>
                                {"Will future behavior match the initial state?"}
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    position: "relative"
                                  }}
                                >
                                  <Toggle
                                    defaultChecked={d.isBusinessReality}
                                    icons={false}
                                    onChange={(e) => updateIsBusinessReality(d.runId, !d.isBusinessReality)}
                                  />
                                  <span className={d.isBusinessReality ? styles.yPosHammer : styles.nPosHammer}>
                                    {d.isBusinessReality ? "Yes" : "No"}
                                  </span>
                                </span>
                              </div>
                              <div className={styles.shareHeader}>
                                <div className={styles.countEditOne} style={{ paddingLeft: "0px" }}>
                                  {"Data Settings"}
                                </div>
                                <div
                                  className={styles.countEditTwo}
                                  style={{
                                    textAlign: isOverallSegment || isBusinessReality ? "right" : "left"
                                  }}
                                >
                                  {"Initial State"}
                                </div>
                                <div
                                  className={styles.countEditThree}
                                  style={{
                                    paddingRight: "0px",
                                    textAlign: isEditCounts ? "left" : "right"
                                  }}
                                >
                                  {"Expected (New)"}
                                </div>
                              </div>
                              {d.isBusinessReality === true ? (
                                <div>
                                  <div className={styles.countItem}>
                                    <div className={styles.countEditOne}>{"Win Rate"}</div>
                                    <div className={styles.countEditTwo}>
                                      {(d.originalOutcomePercentage * 100).toFixed(2) + "%"}
                                    </div>
                                    <div className={styles.countEditThree}>
                                      {(d.outcomePercentage * 100).toFixed(2) + "%"}
                                    </div>
                                  </div>
                                  <div className={styles.countItem}>
                                    <div className={styles.countEditOne}>{d.setup.truePositiveLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.truePositive}</div>
                                    <div className={styles.countEditThree}>{d.setup.truePositive}</div>
                                  </div>
                                  <div className={styles.countItem}>
                                    <div className={styles.countEditOne}>{d.setup.falsePositiveLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.falsePositive}</div>
                                    <div className={styles.countEditThree}>{d.setup.falsePositive}</div>
                                  </div>
                                  <div className={styles.countItem}>
                                    <div className={styles.countEditOne}>{d.setup.trueNegativeLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.trueNegative}</div>
                                    <div className={styles.countEditThree}>{d.setup.trueNegative}</div>
                                  </div>
                                  <div className={styles.countItem}>
                                    <div className={styles.countEditOne}>{d.setup.falseNegativeLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.falseNegative}</div>
                                    <div className={styles.countEditThree}>{d.setup.falseNegative}</div>
                                  </div>
                                  <div className={styles.countItem}>
                                    <div className={styles.countEditOne}>{"Total Population"}</div>
                                    <div className={styles.countEditTwo}>
                                      {Number(d.originalSetup.truePositive) +
                                        Number(d.originalSetup.falsePositive) +
                                        Number(d.originalSetup.trueNegative) +
                                        Number(d.originalSetup.falseNegative)}
                                    </div>
                                    <div className={styles.countEditThree}>{d.scaledTotal}</div>
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <div className={styles.countEditItem}>
                                    <div className={styles.countEditOne}>{"Win Rate"}</div>
                                    <div className={styles.countEditTwo}>
                                      {(d.currentOutcomePercentage * 100).toFixed(2) + "%"}
                                    </div>
                                    <div className={styles.countEditThree}>
                                      <LineInput
                                        isMediumBox
                                        value={(d.outcomePercentage * 100).toFixed(2)}
                                        onChange={(val) => updateOutcomePercentage(d.runId, val / 100)}
                                      />
                                    </div>
                                  </div>
                                  <div className={styles.countEditItem}>
                                    <div className={styles.countEditOne}>{d.setup.truePositiveLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.truePositive}</div>
                                    <div className={styles.countEditThree}>
                                      <LineInput
                                        isMediumBox
                                        value={d.setup.truePositive}
                                        onChange={(val) => updateTruePositive(d.runId, val)}
                                      />
                                    </div>
                                  </div>
                                  <div className={styles.countEditItem}>
                                    <div className={styles.countEditOne}>{d.setup.falsePositiveLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.falsePositive}</div>
                                    <div className={styles.countEditThree}>
                                      <LineInput
                                        isMediumBox
                                        value={d.setup.falsePositive}
                                        onChange={(val) => updateFalsePositive(d.runId, val)}
                                      />
                                    </div>
                                  </div>
                                  <div className={styles.countEditItem}>
                                    <div className={styles.countEditOne}>{d.setup.trueNegativeLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.trueNegative}</div>
                                    <div className={styles.countEditThree}>
                                      <LineInput
                                        isMediumBox
                                        value={d.setup.trueNegative}
                                        onChange={(val) => updateTrueNegative(d.runId, val)}
                                      />
                                    </div>
                                  </div>
                                  <div className={styles.countEditItem}>
                                    <div className={styles.countEditOne}>{d.setup.falseNegativeLabel}</div>
                                    <div className={styles.countEditTwo}>{d.originalSetup.falseNegative}</div>
                                    <div className={styles.countEditThree}>
                                      <LineInput
                                        isMediumBox
                                        value={d.setup.falseNegative}
                                        onChange={(val) => updateFalseNegative(d.runId, val)}
                                      />
                                    </div>
                                  </div>
                                  <div className={styles.countEditItem}>
                                    <div className={styles.countEditOne}>{"Total Population"}</div>
                                    <div className={styles.countEditTwo}>
                                      {Number(d.originalSetup.truePositive) +
                                        Number(d.originalSetup.falsePositive) +
                                        Number(d.originalSetup.trueNegative) +
                                        Number(d.originalSetup.falseNegative)}
                                    </div>
                                    <div className={styles.countEditThree}>
                                      <LineInput
                                        isMediumBox
                                        value={d.scaledTotal}
                                        onChange={(val) => updateScaledTotal(d.runId, Number(val))}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        ) : (
          <div
            className={styles.midHolder}
            style={isShowCurrentState ? { marginTop: "340px" } : { marginTop: "240px" }}
          >
            {project && project.segments && project.segments.length > 1 ? (
              isContinuous ? (
                <div className={styles.midBody}>
                  <div className={styles.midHeader}>
                    <div className={styles.midItem}>{"Overview"}</div>
                    <div className={styles.midItemLarge}>{"Optimal AI from Efficient Frontier"}</div>
                    <div className={styles.midItemLarge} style={{ textAlign: "center" }}>
                      {"Prediction Drivers"}
                    </div>
                    <div className={styles.midItem}>{"Model Metrics"}</div>
                    <div className={styles.midItem}>{"Assumptions"}</div>
                    {/* TODO: Bring back edit for continuous
                    <div className={styles.midEdit}>
                      <Button
                        onClick={() => this.setState({ isOverviewEdit: true })}
                      >
                        {"Edit"}
                      </Button>
                    </div>
                    */}
                  </div>
                  {modelGroups &&
                    modelGroups.drilldownValues &&
                    modelGroups.drilldownValues
                      .filter((d) => d.value !== "Overall")
                      .map((d, i) => {
                        const selectedModel = d.capModels[Math.round(d.capValue) + "%"];

                        let retModels = {};

                        const activeSegment = project.segments.filter((s) => s.id === d.segmentId)[0];

                        const currScenario =
                          (selectedScenario && selectedScenario.scenario && selectedScenario.scenario[d.value]) || {};

                        const scenarioSetup = currScenario.setup || {};

                        const currRunId = currScenario.runId;

                        /*
                        const showMetrics = [
                          { value: "accuracy_score", label: "Accuracy" },
                          { value: "precision_score", label: "Precision" },
                          { value: "recall_score", label: "Recall" },
                          { value: "auc", label: "AUC" },
                          { value: "f1_score", label: "F1 Score" },
                          { value: "log_loss", label: "Log Loss" },
                        ];
                        */

                        const showMetrics = [
                          {
                            value: "mean_absolute_error",
                            label: "Mean Absolute Error"
                          },
                          {
                            value: "mean_squared_error",
                            label: "Mean Squared Error"
                          }
                        ];

                        const mMetrics = [
                          {
                            value: "sum_over_predict",
                            label: "Sum Over Predict"
                          },
                          {
                            value: "sum_under_predict",
                            label: "Sum Under Predict"
                          },
                          {
                            value: "count_over_predict",
                            label: "Count Over Predict"
                          },
                          {
                            value: "count_under_predict",
                            label: "Count Under Predict"
                          }
                        ];

                        const setupMetrics = [
                          {
                            value: "conversionGain",
                            label: "truePositiveLabel"
                          },
                          {
                            value: "conversionCost",
                            label: "falsePositiveLabel"
                          }
                        ];

                        return (
                          <div className={styles.midItemHolder} key={i}>
                            <div className={styles.midItem}>
                              <div className={styles.midFlex}>
                                <div
                                  className={styles.midIcon}
                                  style={{
                                    background: d.color
                                  }}
                                />
                                {d.value}
                              </div>
                              <Button onClick={() => updateDrilldownValue(d.runId, d.value)}>{"View Models"}</Button>
                            </div>
                            <div className={styles.midItemLarge}>
                              <div className={styles.fHideHolder}>
                                <div className={styles.slideSelectHolder}>
                                  <ContinuousRunFrontier
                                    isSingle
                                    frontier={continuousFrontier[i].frontier}
                                    bestModel={
                                      continuousFrontier[i].frontier && continuousFrontier[i].bestModel
                                        ? continuousFrontier[i].frontier.filter(
                                            (m) => m.id === continuousFrontier[i].bestModel.id
                                          ).length > 0
                                          ? continuousFrontier[i].frontier.filter(
                                              (m) => m.id === continuousFrontier[i].bestModel.id
                                            )[0]
                                          : undefined
                                        : undefined
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className={styles.midItemLarge} style={{ height: "190px" }}>
                              <FeatureChartContainer
                                id={d.runId}
                                isHideSelect
                                predictMode={"predict"}
                                featureStyle={{
                                  border: "none",
                                  margin: "0px",
                                  background: "white"
                                }}
                                isTabMini
                                isProjectOverview
                                projectId={project ? project.id : undefined}
                                hideRight
                              />
                            </div>
                            <div className={styles.midItem} style={{ alignSelf: "flex-start" }}>
                              <div className={styles.midLineItem}>
                                <div className={styles.mLeft}>{"Total Cost"}</div>
                                <div
                                  className={styles.mRight}
                                  title={
                                    d.bestModel && d.bestModel.metrics.overImpact + d.bestModel.metrics.underImpact
                                  }
                                >
                                  {numeral(
                                    d.bestModel && d.bestModel.metrics.overImpact + d.bestModel.metrics.underImpact
                                  ).format("0.0a")}
                                </div>
                              </div>
                              {d.bestModel &&
                                showMetrics.map((metric, i) => (
                                  <div className={styles.midLineItem} key={i}>
                                    <div className={styles.mLeft}>{metric.label}</div>
                                    <div className={styles.mRight} title={d.bestModel.metadata[metric.value]}>
                                      {numeral(d.bestModel.metadata[metric.value]).format("0.0a")}
                                    </div>
                                  </div>
                                ))}
                              {d.bestModel &&
                                mMetrics.map((metric, i) => (
                                  <div className={styles.midLineItem} key={i}>
                                    <div className={styles.mLeft}>{metric.label}</div>
                                    <div className={styles.mRight} title={d.bestModel.metrics[metric.value]}>
                                      {numeral(d.bestModel.metrics[metric.value]).format("0.0a")}
                                    </div>
                                  </div>
                                ))}
                            </div>
                            <div className={styles.midItem}>
                              {d.setup &&
                                d.setup.customValues &&
                                Object.keys(d.setup.customValues).map((assumption, i) => (
                                  <div className={styles.midLineItem} key={i}>
                                    <div className={styles.mLeft}>{assumption}</div>
                                    <div className={styles.mRight}>{d.setup.customValues[assumption]}</div>
                                  </div>
                                ))}
                              {d.setup &&
                                setupMetrics.map((assumption, i) => (
                                  <div className={styles.midLineItem} key={i}>
                                    <div className={styles.mLeft}>{d.setup[assumption.label]}</div>
                                    <div className={styles.mRight}>{Math.abs(d.setup[assumption.value])}</div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        );
                      })}
                </div>
              ) : (
                <div className={styles.midBody}>
                  <div className={styles.midHeader}>
                    <div className={styles.midItem}>{"Overview"}</div>
                    <div className={styles.midItemLarge}>{"Optimal AI from Efficient Frontier"}</div>
                    <div className={styles.midItemLarge} style={{ textAlign: "center" }}>
                      {"Prediction Drivers"}
                    </div>
                    <div className={styles.midItem}>{"Model Metrics"}</div>
                    <div className={styles.midItem}>{"Assumptions"}</div>
                    <div className={styles.midEdit}>
                      <Button onClick={() => this.setState({ isOverviewEdit: true })}>{"Edit"}</Button>
                    </div>
                  </div>
                  {modelGroups &&
                    modelGroups.drilldownValues &&
                    modelGroups.drilldownValues
                      .filter((d) => d.value !== "Overall")
                      .map((d, i) => {
                        const selectedModel = d.capModels[Math.round(d.capValue) + "%"];

                        let retModels = { ...d.capModels };

                        const activeSegment = project.segments.filter((s) => s.id === d.segmentId)[0];

                        const currScenario =
                          (selectedScenario && selectedScenario.scenario && selectedScenario.scenario[d.value]) || {};

                        const scenarioSetup = currScenario.setup || {};

                        const currRunId = currScenario.runId;

                        const frontierMin = 0;
                        const frontierMax = 100;

                        const showMetrics = [
                          { value: "accuracy_score", label: "Accuracy" },
                          { value: "precision_score", label: "Precision" },
                          { value: "recall_score", label: "Recall" },
                          { value: "auc", label: "AUC" },
                          { value: "f1_score", label: "F1 Score" },
                          { value: "log_loss", label: "Log Loss" }
                        ];

                        const setupMetrics = [
                          {
                            value: "conversionGain",
                            label: "truePositiveLabel"
                          },
                          {
                            value: "conversionCost",
                            label: "falsePositiveLabel"
                          }
                        ];

                        return (
                          <div className={styles.midItemHolder} key={i}>
                            <div className={styles.midItem}>
                              <div className={styles.midFlex}>
                                <div
                                  className={styles.midIcon}
                                  style={{
                                    background: d.color
                                  }}
                                />
                                {d.value}
                              </div>
                              <Button onClick={() => updateDrilldownValue(d.runId, d.value)}>{"View Models"}</Button>
                            </div>
                            <div className={styles.midItemLarge}>
                              <div
                                className={styles.fHideHolder}
                                style={
                                  sliderView === FRONTIER_SLIDERS_VIEW.HIDE
                                    ? { maxHeight: "0px", overflow: "hidden" }
                                    : {}
                                }
                              >
                                <div className={styles.slideSelectHolder}>
                                  <CapSlider
                                    key={"cap" + d.value + i}
                                    isEditFrontierRange={false}
                                    frontierRange={[frontierMin, frontierMax]}
                                    impacts={
                                      project.settings && project.settings.scenarios
                                        ? [
                                            ...project.settings.scenarios
                                              .filter((s, i) =>
                                                showShortListed === false &&
                                                project.settings.originalScenarios &&
                                                project.settings.originalScenarios[i] &&
                                                project.settings.originalScenarios[i].status === "PENDING"
                                                  ? false
                                                  : true
                                              )
                                              .filter((s, i) =>
                                                showPending === false &&
                                                project.settings.originalScenarios &&
                                                project.settings.originalScenarios[i] &&
                                                project.settings.originalScenarios[i].status === "DRAFT"
                                                  ? false
                                                  : true
                                              )
                                              .map((s, i) => ({
                                                value: Math.min(s[d.value].capValue, 100),
                                                drilldownValue: "Scenario " + i
                                              })),
                                            {
                                              value: d.capValue,
                                              drilldownValue: d.value
                                            }
                                          ]
                                        : [
                                            {
                                              value: d.capValue,
                                              drilldownValue: d.value
                                            }
                                          ]
                                    }
                                    currentImpact={Math.min(d.capValue, 100)}
                                    drilldownValue={d.value}
                                    capModels={retModels}
                                    drilldown={d}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className={styles.midItemLarge} style={{ height: "190px" }}>
                              <FeatureChartContainer
                                id={d.runId}
                                isHideSelect
                                predictMode={"predict"}
                                featureStyle={{
                                  border: "none",
                                  margin: "0px",
                                  background: "white"
                                }}
                                isTabMini
                                isProjectOverview
                                projectId={project ? project.id : undefined}
                                hideRight
                              />
                            </div>
                            <div className={styles.midItem} style={{ alignSelf: "flex-start" }}>
                              <div className={styles.midLineItem}>
                                <div className={styles.mLeft}>{"Impact"}</div>
                                <div className={styles.mRight}>
                                  {d.bestModel && d.bestModel.maxIteration.displayImpact}
                                </div>
                              </div>
                              {d.bestModel && (
                                <div className={styles.midLineItem}>
                                  <div className={styles.mLeft}>{"Total Positives"}</div>
                                  <div className={styles.mRight}>
                                    {d.bestModel.maxIteration.confusionMatrix.getAllPositive()}
                                  </div>
                                </div>
                              )}
                              {d.bestModel &&
                                showMetrics.map((metric, i) => (
                                  <div className={styles.midLineItem} key={i}>
                                    <div className={styles.mLeft}>{metric.label}</div>
                                    <div className={styles.mRight}>{d.bestModel.metadata[metric.value].toFixed(2)}</div>
                                  </div>
                                ))}
                              {d.bestModel && (
                                <div className={styles.midLineItem}>
                                  <div className={styles.mLeft}>{"Threshold"}</div>
                                  <div className={styles.mRight}>{d.bestModel.maxIteration.threshold.toFixed(2)}</div>
                                </div>
                              )}
                              {d.bestModel && (
                                <div className={styles.midLineItem}>
                                  <div className={styles.mLeft}>{"MCC"}</div>
                                  <div className={styles.mRight}>
                                    {d.bestModel.maxIteration.confusionMatrix
                                      .getMatthewsCorrelationCoefficient()
                                      .toFixed(5)}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className={styles.midItem}>
                              {d.setup &&
                                d.setup.customValues &&
                                Object.keys(d.setup.customValues).map((assumption, i) => (
                                  <div className={styles.midLineItem} key={i}>
                                    <div className={styles.mLeft}>{assumption}</div>
                                    <div className={styles.mRight}>{d.setup.customValues[assumption]}</div>
                                  </div>
                                ))}
                              {d.setup &&
                                setupMetrics.map((assumption, i) => (
                                  <div className={styles.midLineItem} key={i}>
                                    <div className={styles.mLeft}>{d.setup[assumption.label]}</div>
                                    <div className={styles.mRight}>{d.setup[assumption.value]}</div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        );
                      })}
                </div>
              )
            ) : (
              <div style={{ marginTop: "50px" }} />
            )}
          </div>
        )}
        <div className={styles.overallBody}></div>
      </div>
    );
  }

  renderAssumptionItem(setup, assSetup, labelKey, valueKey, countKey, forceLabel = undefined) {
    const { optimized } = this.props;

    const label = forceLabel ? forceLabel : setup[labelKey];
    const value = setup[valueKey];
    const oldValue = assSetup ? assSetup[valueKey] : value;
    const count = setup[countKey];
    const oldCount = assSetup ? assSetup[countKey] : count;

    const isValueDifferent = Number(value) !== Number(oldValue);
    const isCountDifferent = Number(count) !== Number(oldCount);

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    return (
      <div className={styles.oSlice}>
        <div className={styles.oBodyItem}>
          <div className={styles.oBodyItemLabel} title={label}>
            {label + ":"}
          </div>
          <div
            className={isValueDifferent ? styles.oBodyItemContentChange : styles.oBodyItemContent}
            title={isValueDifferent ? `Changed from ${oldValue} to ${value}` : value}
          >
            {`${value}${isValueDifferent ? "*" : ""}`}
          </div>
        </div>
        {isContinuous ? (
          <div />
        ) : (
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div
              className={isCountDifferent ? styles.oBodyItemContentChange : styles.oBodyItemContent}
              title={isCountDifferent ? `Changed from ${oldCount} to ${count}` : value}
            >
              {`${count}${isCountDifferent ? "*" : ""}`}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderCustomAssumptionItem(setup, assSetup, customKey) {
    const label = customKey;
    const value = setup.customValues[customKey];
    const oldValue = assSetup ? assSetup.customValues[customKey] : value;

    const isValueDifferent = Number(value) !== Number(oldValue);

    return (
      <div className={styles.oSlice} key={label}>
        <div className={styles.oBodyItem}>
          <div className={styles.oBodyItemLabel} title={label}>
            {label + ":"}
          </div>
          <div
            className={isValueDifferent ? styles.oBodyItemContentChange : styles.oBodyItemContent}
            title={isValueDifferent ? `Changed from ${oldValue} to ${value}` : value}
          >
            {`${value}${isValueDifferent ? "*" : ""}`}
          </div>
        </div>
      </div>
    );
  }

  renderAssumptionsSetup(setup, assSetup = undefined) {
    const { optimized } = this.props;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    return (
      <div className={styles.assumptionBody}>
        {setup &&
          setup.customValues &&
          Object.keys(setup.customValues).map((c) => this.renderCustomAssumptionItem(setup, assSetup, c))}
        {isContinuous ? (
          <div>
            {this.renderAssumptionItem(
              setup,
              assSetup,
              "truePositiveLabel",
              "conversionGain",
              "truePositive",
              "Overestimate"
            )}
            {this.renderAssumptionItem(
              setup,
              assSetup,
              "falsePositiveLabel",
              "conversionCost",
              "falsePositive",
              "Underestimate"
            )}
          </div>
        ) : (
          <div>
            {this.renderAssumptionItem(setup, assSetup, "truePositiveLabel", "conversionGain", "truePositive")}
            {this.renderAssumptionItem(setup, assSetup, "falsePositiveLabel", "conversionCost", "falsePositive")}
            {this.renderAssumptionItem(setup, assSetup, "trueNegativeLabel", "conversionSaved", "trueNegative")}
            {this.renderAssumptionItem(setup, assSetup, "falseNegativeLabel", "conversionMissed", "falseNegative")}
          </div>
        )}
      </div>
    );
  }

  renderAssumptions() {
    const {
      optimizer,
      optimized,
      modelGroups,
      resetCosts,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative
    } = this.props;

    return (
      <div className={styles.oBodySection}>
        <div className={styles.oBodyHeader}>{"Approved"}</div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.truePositiveLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionGain}
                onChange={(val) => updateConversionGain(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.truePositive}
                onChange={(val) => updateTruePositive(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.falsePositiveLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionCost}
                onChange={(val) => updateConversionCost(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.falsePositive}
                onChange={(val) => updateFalsePositive(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.trueNegativeLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionSaved}
                onChange={(val) => updateConversionSaved(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.trueNegative}
                onChange={(val) => updateTrueNegative(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.falseNegativeLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionMissed}
                onChange={(val) => updateConversionMissed(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.falseNegative}
                onChange={(val) => updateFalseNegative(optimized.id, val)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderRightPanel() {
    const {
      optimizer,
      optimized,
      modelGroups,
      resetCosts,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative
    } = this.props;
    const { isRightOpen } = this.state;

    return (
      <div className={styles.rightPanel + " " + (isRightOpen ? styles.rightOpen : "")}>
        <div className={styles.rightHeader}>{"Impacts"}</div>
        <div className={styles.rightContent}>
          {optimized && optimized && optimized.setup && (
            <div className={styles.oBodySection}>
              <div className={styles.oBodyHeader}>{"Marketing"}</div>
              <div>{optimized.setup.label}</div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.truePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionGain}
                      onChange={(val) => updateConversionGain(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.truePositive}
                      onChange={(val) => updateTruePositive(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.falsePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionCost}
                      onChange={(val) => updateConversionCost(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.falsePositive}
                      onChange={(val) => updateFalsePositive(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.trueNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionSaved}
                      onChange={(val) => updateConversionSaved(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.trueNegative}
                      onChange={(val) => updateTrueNegative(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.falseNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionMissed}
                      onChange={(val) => updateConversionMissed(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.falseNegative}
                      onChange={(val) => updateFalseNegative(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {optimized && optimized.second && optimized.second.setup && (
            <div className={styles.oBodySection}>
              <div className={styles.oBodyHeader}>{"Sales"}</div>
              <div>{optimized.second.setup.label}</div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.truePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionGain}
                      onChange={(val) => updateConversionGain(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.truePositive}
                      onChange={(val) => updateTruePositive(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.falsePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionCost}
                      onChange={(val) => updateConversionCost(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.falsePositive}
                      onChange={(val) => updateFalsePositive(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.trueNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionSaved}
                      onChange={(val) => updateConversionSaved(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.trueNegative}
                      onChange={(val) => updateTrueNegative(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.falseNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionMissed}
                      onChange={(val) => updateConversionMissed(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.falseNegative}
                      onChange={(val) => updateFalseNegative(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSubControls() {
    const { optimizer, optimized, setMarketingBudget, setSalesBudget, setOverallScaleFromRowCount } = this.props;
    const { mode, timePeriod, prospects, mBudget, sStaffing, leads, wins } = this.state;

    return (
      <div className={styles.tHeader}>
        {/*
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Time Period"}</div>
          <div className={styles.tInput}>
            <Select
              options={[
                { value: "Day", label: "Day" },
                { value: "Week", label: "Week" },
                { value: "Month", label: "Month" },
                { value: "Quarter", label: "Quarter" },
                { value: "Year", label: "Year" }
              ]}
              value={timePeriod}
              onChange={val => this.setState({ timePeriod: val })}
              className={styles.tSelect}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
      */}
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Marketing Budget"}</div>
          <div className={styles.tInput}>
            <LineInput isMediumBox isDark defaultValue={optimized.budget} onChange={(val) => setMarketingBudget(val)} />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Sales Budget"}</div>
          <div className={styles.tInput}>
            <LineInput
              isMediumBox
              isDark
              defaultValue={optimized.second.budget}
              onChange={(val) => setSalesBudget(val)}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Total Prospects"}</div>
          <div className={styles.tInput}>
            <LineInput
              isMediumBox
              isDark
              defaultValue={optimized.totalProspects}
              onChange={(val) => setOverallScaleFromRowCount(val)}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Marketing Qualified Leads"}</div>
          <div className={styles.tInput}>
            <NumericLabel params={numberFormatParams}>{optimized.totalWon}</NumericLabel>
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem} style={{ borderRight: "0px" }}>
          <div className={styles.tTitle}>{"Wins"}</div>
          <div className={styles.tInput}>
            <NumericLabel params={numberFormatParams}>{optimized.second.totalWon}</NumericLabel>
          </div>
          <div className={styles.tSub}></div>
        </div>
      </div>
    );
  }

  renderDrilldown() {
    const { optimizer, optimized, setMarketingBudget, setSalesBudget, modelGroups } = this.props;
    const { mode, timePeriod, prospects, mBudget, sStaffing, leads, wins } = this.state;

    return (
      <div className={styles.drilldown}>
        {/* this.renderSubControls() */}
        <div className={styles.sHeader}>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Marketing Spend"}</div>
            <div className={styles.sHero}>
              {(optimized.totalCost < 0 ? "-" : "") + optimized.unitLabelShort}
              <NumericLabel params={numberFormatParams}>{Math.abs(optimized.totalCost)}</NumericLabel>
            </div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Per Lead Cost"}</div>
            <div className={styles.sHero}>
              {(optimized.totalCost < 0 ? "-" : "") + optimized.unitLabelShort}
              <NumericLabel params={numberFormatParams}>{Math.abs(optimized.setup.conversionCost)}</NumericLabel>
            </div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Expected Leads"}</div>
            <div className={styles.sHero}>{Math.round(optimized.totalWon)}</div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Sales Expense"}</div>
            <div className={styles.sHero}>
              {(optimized.second.totalCost < 0 ? "-" : "") + optimized.unitLabelShort}
              <NumericLabel params={numberFormatParams}>{Math.abs(optimized.second.totalCost)}</NumericLabel>
            </div>
          </div>
          <div className={styles.sItem} style={{ marginRight: "350px" }}>
            <div className={styles.sTitle}>{"Wins"}</div>
            <div className={styles.sHero}>{Math.round(optimized.second.totalWon)}</div>
          </div>
        </div>
        <div className={styles.oBody}>
          {<SankeyChart optimized={optimized} />}
          {this.renderProfitBox(
            {
              marginTop: "0px",
              marginBottom: "575px",
              textAlign: "center",
              whiteSpace: "nowrap",
              marginRight: "20px",
              marginLeft: "-50px",
              zIndex: "2"
            },
            true
          )}
        </div>
      </div>
    );
  }
}
